import { PsHttpService, type PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';
import type {
    EurekaAllHistoryApi,
    EurekaAllHistoryResponse,
} from '../eureka-all-history-api';

/** 基于统一任务列表接口的 Eureka 全部历史 API 实现。 */
@injectable()
export class EurekaAllHistoryApiImpl extends PsHttpService implements EurekaAllHistoryApi {
    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    /** 使用 ALL 类型查询当前账号的第一条历史任务。 */
    async getAllHistory(): Promise<EurekaAllHistoryResponse> {
        const result = await this.get<PatSnapSuccessResponseData<EurekaAllHistoryResponse>>({
            url: 'ai/task/task-list',
            params: {
                page: 1,
                limit: 1,
                type: 'ALL',
            },
        });
        return result.data;
    }
}
